import { ImageElementType } from "app/common/constants/structuredText"
import { variantsToSrcSet } from "app/common/utilities/html"
import getImage from "app/media/queries/getImage"
import { useQuery } from "blitz"
import { either } from "fp-ts"
import { pipe } from "fp-ts/function"
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react"
import { useFocused, useSelected } from "slate-react"
import { tw } from "twind"

type ImageElementProps = PropsWithChildren<{
  attributes: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  element: ImageElementType
}>

export const ImageElement = ({ attributes, children, element }: ImageElementProps) => {
  const selected = useSelected()

  const focused = useFocused()

  const [imageOrError] = useQuery(getImage, { id: element.id })

  return (
    <div {...attributes} contentEditable={false}>
      <>
        {pipe(
          imageOrError,
          either.map((image) => (
            <figure key={image.url}>
              <img
                alt={element.caption}
                className={tw(
                  `w-80`,
                  `overflow-hidden`,
                  `block`,
                  selected && focused && `ring(4 blue-300)`
                )}
                height={image.height}
                sizes={"20rem"}
                src={image.url}
                srcSet={variantsToSrcSet(image.variants)}
                width={image.width}
              />
              <figcaption className={tw(`text-gray-800 italic`, `py-2`, `cursor-pointer`)}>
                {element.caption}
              </figcaption>
            </figure>
          )),
          either.getOrElse(() => <></>)
        )}
        {children}
      </>
    </div>
  )
}
